import { api, apiBaseUrl } from './client';

export interface Cliente {
  id: number;
  identificacion: string;
  dv: string | null;
  tipo_documento: string;
  tipo_persona: string;
  nombre: string;
  email?: string | null;
  telefono?: string | null;
  direccion?: string | null;
}

/** Lista clientes (búsqueda opcional por nombre o identificación).
 *  orden='recientes' → el último creado primero (para el panel de facturación). */
export const listClientes = (q = '', orden?: 'recientes') =>
  api.get<{ clientes: Cliente[] }>(
    `/api/clientes?q=${encodeURIComponent(q)}${orden ? `&orden=${orden}` : ''}`
  );

/** Datos que el cliente final llena en el formulario público de facturación. */
export interface ClientePublicoInput {
  tipo_documento: string;
  identificacion: string;
  dv?: string | number;
  tipo_persona: string;
  nombre: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  responsabilidad_fiscal?: string;
}

/** Crea/actualiza un cliente desde la página pública (SIN login). */
export async function crearClientePublico(data: ClientePublicoInput): Promise<{ ok: boolean; id: number; nombre: string }> {
  const r = await fetch(`${apiBaseUrl}/api/public/clientes-fe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j?.error || `HTTP ${r.status}`);
  return j;
}

/** Busca un cliente por identificación. Devuelve null si no existe. */
export const buscarCliente = (identificacion: string) =>
  api.get<{ cliente: Cliente | null }>(
    `/api/clientes?identificacion=${encodeURIComponent(identificacion)}`
  );

/** Busca-o-crea un cliente (upsert por identificación). */
export const upsertCliente = (data: {
  tipo_documento: string;
  identificacion: string;
  nombre: string;
  dv?: number | string;
  tipo_persona?: string;
  email?: string;
  telefono?: string;
  direccion?: string;
}) => api.post<{ cliente: Cliente }>('/api/clientes', data);
